export interface PTZAutoTracking {
    TrackEnable: AutoTrackingEnable;
    ShowAutoEnable: AutoTrackingEnable;
    ReportMotion: AutoTrackingEnable;
    Sensitivity: number;
    MaxTime: number;
    Object: DetectionObject;
    ZoomMode: AutoTrackingZoomRatio;
    ZoomNumber: number;
    ZoomState: AutoTrackingEnable;
    TrackMap: string;
    ScheduleList: Schedule[];
}

export enum AutoTrackingEnable {
    No,
    Yes,
}

export enum DetectionObject {
    None,
    OnlyPerson,
    OnlyVehicle,
    PersonAndVehicle,
}

export enum AutoTrackingZoomRatio {
    Auto,
    Customize,
}

 export interface Schedule {
    ScheduleIndex: number;
    Schedule: string;
}
